import React from 'react';
import { LOCATION_DATA_GET_LOCATIONS_URL } from '../../services/config';
import { getHeaders } from '../../services/fetch';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import Moment from 'moment';
import PropTypes from 'prop-types';

class ReportFilter extends React.Component {

  static async getLocations() {
    const response = await fetch(
      LOCATION_DATA_GET_LOCATIONS_URL,
      {
        headers: {
          ...getHeaders()
        }
      }
    );
    return response.json();
  }

  state = {
    location: null,
    from: '',
    to: '',
    error: null,
    locations: null,
    isLoading: false
  };

  constructor(props) {
    super(props);

    this.state.from = Moment().add(-7, 'days').format('YYYY-MM-DD');
    this.state.to = Moment().format('YYYY-MM-DD')
  }

  componentDidMount() {
    this.loadLocations()
      .catch(error => this.setState({
        error,
        isLoading: false
      }));
  }

  async loadLocations() {
    await new Promise(resolve => this.setState({
      isLoading: true
    }, resolve));
    try {
      const locations = await ReportFilter.getLocations();
      await new Promise(resolve => this.setState({
        locations,
        location: locations[0]
      }, resolve));
      this.onFilter();
    } catch(error) {
      await new Promise(resolve => this.setState({
        error
      }, resolve));
    }
    await new Promise(resolve => this.setState({
      isLoading: false
    }, resolve));
  }

  isValid() {
    return (
      this.state.location &&
      this.state.from  &&
      this.state.to &&
      /^\d{4}-\d{2}-\d{2}$/.test(this.state.from) &&
      /^\d{4}-\d{2}-\d{2}$/.test(this.state.to) &&
      Moment(this.state.from, 'YYYY-MM-DD').isBefore(Moment(this.state.to, 'YYYY-MM-DD'))
    )
  }

  onFilter = () => {
    if (!this.isValid()) {
      return;
    }
    this.props.onFilter({
      location: this.state.location,
      startDate: this.state.from,
      endDate: this.state.to,
    });
  };

  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    }, this.onFilter);
  };

  render() {
    if (this.state.error) {
      return <p>An error occurred</p>
    }
    if (this.state.isLoading || !Array.isArray(this.state.locations)) {
      return <p>Loading...</p>
    }
    return (
      <React.Fragment>
        <Form className="d-print-none">
          <FormGroup>
            <Label for="location">Location</Label>
            <Input type="select" name="location" id="location" onChange={this.onChange} value={this.state.location}>
              {
                this.state.locations.map(
                  (location, index) => <option value={location} key={index}>{location}</option>
                )
              }
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="from">From</Label>
            <Input type="date" name="from" id="from" value={this.state.from} max={this.state.to} onChange={this.onChange} />
          </FormGroup>
          <FormGroup>
            <Label for="to">To</Label>
            <Input type="date" name="to" id="to" value={this.state.to} min={this.state.from} onChange={this.onChange} />
          </FormGroup>
        </Form>
      </React.Fragment>
    )
  }

}

ReportFilter.propTypes = {
  onFilter: PropTypes.func.isRequired
}

export default ReportFilter;


// WEBPACK FOOTER //
// ./src/app/report/filter.js